import React from 'react'
import Banner from './Banner'
import NavBar from './NavBar'
import FillCard from './FillCard'
import SectionHeading from './SectionHeading'
import VirtualTour from './VirtualTour'
import MapLocation from './MapLocation'





function Home() {
  return (
    <>
        <NavBar />
        <Banner/>
       <SectionHeading title="Our Featured Rooms"/>
       
        <FillCard/>

        <SectionHeading title="Locality Virtual View"/>
        <VirtualTour/>
        <SectionHeading title="Come Visit Us"/>
       <MapLocation/>
     
        
  
      </>
  )
}



export default Home












